import React from "react";
import { Route } from "react-router-dom";
import Estimate from "../../pages/estimate";
import PrivateRoute from "../../PrivateRoute";

export const estimate = (
  <>
    <Route path="/estimate" element={<PrivateRoute><Estimate /></PrivateRoute>} />
  </>
);
